export default [
  {
    component: () => import("@/components/faturamento/cadastros/representante/editor-representante.vue"),
    name: "vendas.equipe.representantes.novo",
    label: "Cadastrar Representantes",
    path: "/vendas/equipe/representantes/cadastro",
  },
  {
    component: () => import("@/components/faturamento/cadastros/representante/editor-representante.vue"),
    name: "vendas.equipe.representantes.editar",
    label: "Editar Representantes",
    path: "/vendas/equipe/representantes/editar/:id",
  },
  {
    component: () => import("@/components/equipe/MenuEquipe.vue"),
    name: "vendas.equipe",
    path: "/vendas/equipe",
    label: "Equipe",
  },
  {
    component: () => import("@/components/faturamento/vendas/supervisor/minha-equipe.vue"),
    name: "vendas.equipe.equipe-vendas",
    path: "/vendas/equipe/equipe-vendas",
    label: "Visualizar Equipe de Vendas",
  },
  {
    component: () => import("@/components/faturamento/cadastros/representante/representantes.vue"),
    name: "vendas.equipe.representantes",
    path: "/vendas/equipe/representantes/gerenciar",
    label: "Visualizar Representantes",
  },
  {
    component: () => import("@/components/faturamento/cadastros/representante-grupo/representante-grupos.vue"),
    path: "/vendas/equipe/grupos-representantes",
    name: "vendas.equipe.grupos-representantes",
    label: "Visualizar Grupos de Representantes",
  },
  {
    component: () => import("@/components/vendas/MenuVendas.vue"),
    name: "vendas",
    path: "/vendas",
    label: "Gestão de Vendas",
  },
  {
    component: () => import("@/components/vendas/MenuGestaoPrecos.vue"),
    name: "vendas.gestao-precos",
    path: "/vendas/gestao-precos",
    label: "Gestão de Preços",
  },
];
